import api from './api';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// // Create axios instance with default config - matching authService configuration
// const api = axios.create({
//   baseURL: API_URL,
//   withCredentials: true, // Critical for session cookies
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

// // Add request interceptor for authentication
// api.interceptors.request.use(
//   (config) => {
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// // Add response interceptor for error handling
// api.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Only handle 401 (Unauthorized) - not 500 (Server Error) or other errors
//     // Session expiration should only be triggered by actual authentication failures, not server errors
//     if (error.response?.status === 401) {
//       const errorMessage = error.response?.data?.message || '';
//       // Only redirect if it's explicitly a session expiration, not a general auth error
//       if (errorMessage.includes('Session expired') || errorMessage.includes('Session timeout') || errorMessage.includes('Authentication required')) {
//         console.error('Authentication required for billing API');
//         if (window.location.pathname !== '/login') {
//           // Clear authentication state
//           localStorage.removeItem('user');
//           localStorage.removeItem('isAuthenticated');
//           // Redirect to login with session expired message
//           window.location.href = '/login?session=expired';
//         }
//       }
//     }
//     // For 500 errors and other errors, just reject - don't treat as session expiration
//     return Promise.reject(error);
//   }
// );

const billingService = {
  /**
   * Get all practices for billing selection
   */
  getBillingPractices: async () => {
    try {
      const response = await api.get('/billing/practices');
      return response.data;
    } catch (error) {
      console.error('Error fetching billing practices:', error);
      throw error;
    }
  },

  /**
   * Get billing reports for a practice
   * @param {number} practiceId - Practice ID
   * @param {object} params - Query parameters (startDate, endDate, rpmStartDate, rpmEndDate)
   */
  getBillingReports: async (practiceId, params = {}) => {
    try {
      const response = await api.get(`/billing/reports/${practiceId}`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching billing reports:', error);
      throw error;
    }
  },

  /**
   * Save report date
   * @param {object} reportDateData - Report date data
   */
  saveReportDate: async (reportDateData) => {
    try {
      const response = await api.post('/billing/report-dates', reportDateData);
      return response.data;
    } catch (error) {
      console.error('Error saving report date:', error);
      throw error;
    }
  },

  /**
   * Delete report date
   * @param {number} reportDateId - Report date ID
   */
  deleteReportDate: async (reportDateId) => {
    try {
      const response = await api.delete(`/billing/report-dates/${reportDateId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting report date:', error);
      throw error;
    }
  },

  /**
   * Get billing dashboard data (practices with patient counts)
   */
  getBillingDashboard: async () => {
    try {
      const response = await api.get('/billing/dashboard');
      return response.data;
    } catch (error) {
      console.error('Error fetching billing dashboard:', error);
      throw error;
    }
  },

  /**
   * Get billing options for dropdowns
   * @param {number} practiceId - Practice ID
   */
  getBillingOptions: async (practiceId) => {
    try {
      const response = await api.get(`/billing/options/${practiceId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching billing options:', error);
      throw error;
    }
  }
};

export default billingService;

